import React, { FC, memo } from 'react';
import {
  ChannelList as StreamChannelList,
  ChannelListMessenger,
  ChannelSort,
  ChannelPreviewUIComponentProps,
} from 'stream-chat-react';

import { Events } from 'analytics';
import { useCurrentUser } from 'hooks';

import ChannelPreview from './ChannelPreview';

interface IProps {
  onToggleDrawer?: () => void;
}

const ChannelList: FC<IProps> = ({ onToggleDrawer }) => {
  const currentUser = useCurrentUser();

  const filters = { type: 'comments', members: { $in: [currentUser.id] } };
  const sort: ChannelSort = { last_message_at: -1 };

  function renderPreview(props: ChannelPreviewUIComponentProps) {
    return <ChannelPreview {...props} onToggleDrawer={onToggleDrawer} />;
  }

  return (
    <StreamChannelList
      filters={filters}
      sort={sort}
      EmptyStateIndicator={() => null}
      List={ChannelListMessenger}
      Preview={renderPreview}
      onAddedToChannel={() => {
        window?.analytics?.track(Events.DiscussionSubscribed);
      }}
    />
  );
};

ChannelList.defaultProps = {
  onToggleDrawer: () => undefined,
};

export default memo(ChannelList);
